export const tasks = [
  {
    task: "Complete Q4 Project Milestones",
    progress: 75, 
    due: "Dec 31, 2025",
  },
  {
    task: "Mentor 2 Junior Developers",
    progress: 50,
    due: "Dec 15, 2025",
  },
  {
    task: "Submit 3 Technical Blogs",
    progress: 33,
    due: "Nov 30, 2025",
  },
];
